import axios from 'axios';

import { API_BASE_URL } from '@/constants';

export async function fetchImpactoStats(): Promise<StatsResponse> {
  const response = await axios.get<StatsResponse>(`${API_BASE_URL}/pets/stats/`);
  return response.data;
}
